export default __webpack_public_path__ + "static/media/alpha-uni-closed-logo.c9d2c447.svg";